import React from 'react'
import { PropTypes } from 'prop-types'
import DOMPurify from 'dompurify'

const HippostdHtml = ({ value, classNames }) => {
  return value ? (
    <div className={`HippostdHtml Content ${classNames || ''}`}>
      <div
        className="cms-content"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }}
      ></div>
    </div>
  ) : null
}

HippostdHtml.propTypes = {
  value: PropTypes.string,
  classNames: PropTypes.string,
}

export { HippostdHtml }
